import type { ApiListRequest, ApiListResponse } from "../@types/services/Api";
import type {
  AssignmentRule,
  AssignmentRuleFilter,
  AssignmentRuleIndex,
  AssignmentRuleNew,
  AssignmentRuleShow,
  AssignmentRuleUpdate,
} from "../@types/services/AssignmentRule";
import { api } from "./api";

const API_BASE_URL = "/api/v2/mm_request_assignment_rules";

export const fetchAssignmentRules = async ({
  filters,
  ...rest
}: ApiListRequest<AssignmentRuleFilter> = {}): Promise<
  ApiListResponse<AssignmentRuleIndex>
> => {
  const response = await api.get("", {
    baseURL: API_BASE_URL,
    params: {
      ...filters,
      ...rest,
    },
  });
  return response.data;
};

export const fetchAssignmentRule = async (
  id: string,
): Promise<AssignmentRuleShow> => {
  const response = await api.get(`/mm_request_assignment_rules/${id}`, {
    baseURL: "/api/v2",
  });
  return response.data;
};

export const createAssignmentRule = async (
  data: AssignmentRuleNew,
): Promise<AssignmentRule> => {
  const response = await api.post(`/mm_request_assignment_rules`, data, {
    baseURL: "/api/v2",
  });
  return response.data;
};

export const deleteAssignmentRule = async (
  id: string | number,
): Promise<void> => {
  await api.delete(`/mm_request_assignment_rules/${id}`, {
    baseURL: "/api/v2",
  });
};

export const updateAssignmentRule = async (
  data: AssignmentRuleUpdate,
): Promise<AssignmentRule> => {
  const response = await api.put(
    `/mm_request_assignment_rules/${data.id}`,
    data,
    {
      baseURL: "/api/v2",
    },
  );
  return response.data;
};
